import BaseService from './BaseService';

export default class CrudService extends BaseService {
	constructor(entityClass) {
		super();
		this.entityClass = entityClass;
		this.dataListListeners = [];
		this.dataList = [];

	}

	registerDatalistListener(listener) {
		this.dataListListeners.push(listener);

	}

	notifyDatalistUpdate() {
		for (var listener of this.dataListListeners) {
			listener.datalistUpdated();
		}
	}

	listAll(listUrl) {
		this.opencellAPI.callApi(listUrl).then(entityList => {
			this.dataList = [];
			for (let entity of entityList) {
				this.dataList.push(this.entityClass.convertFromProperties(entity));
			}
			this.notifyDatalistUpdate();
		});
	}

	persist(entity, callback) {
		this.dataList.push(entity);
		this.opencellAPI_selfWS.createCRMAccountHierarchy(entity)
			.then(response => {
				if (callback) {
					callback('success', response);
				}
			})
			.catch(error => {
				this.dataList.pop();
				if (callback) {
					callback('error', error);
				}
			});
	}

	update(entity, callback) {
		this.opencellAPI.updateCRMAccountHierarchy(entity).then(response => {
				if (callback) {
					callback('success', response);
				}
			},
			error => {
				if (callback) {
					callback('error', error);
				}
			}
		);
	}

	updateUser(user, callback) {
    	this.opencellAPI.updateUser(user).then(response => {
				if (callback) {
					callback('success', response);
				}
			},
			error => {
				if (callback) {
					callback('error', error);
				}
			}
		);
	}

	resetPassword(pwd, callback) {
		this.opencellAPI.resetPassword(pwd).then(response => {
				if (callback) {
					this.notifyActionSuccess("reset password");
					callback('success', response);
				}
			},
			error => {
				this.dataList.pop();
				if (callback) {
					this.notifyActionFailure("reset password");
					callback('error', error);
				}
			}
		);
	}

}



// WEBPACK FOOTER //
// ./src/opencell/services/CrudService.js